import { Button, Grid, Typography } from "@mui/material";
import "../AppMobileXS.css";
import ButtonCeci from "./ButtonCeci";

export default function Card4() {
    return (
        <>
        <Grid container size={12} sx={{width: '80%', marginLeft: '10%', marginRight: '10%', marginTop: '15vh'}}>
            <Grid item size={12} sx={{textAlign: 'left'}}>
                <div className="stile-titolo bianco">Quando <br/>rivolgersi a me</div>
                <div style={{marginTop: '6vw'}}className="stile-sottotitolo bianco">Per imparare a muovere il corpo in modo autonomo e consapevole, riscoprendo i benefici del movimento attraverso un percorso olistico e personalizzato, costruito sulle tue esigenze e i tuoi obiettivi</div>                
            </Grid>
        </Grid>
        <img src="/assets/mobile/Card_4.svg" style={{ width: '100%', marginBottom: '7vh', marginTop: "8vh"}}/>        
        </>
    );
}
